export default __webpack_public_path__ + "static/july-sale-mobile-cd40591e9bf49075b69ad710e1bcd10f.webp";